import { useState, useMemo, useEffect } from "react";
import {
  Box,
  Input,
  InputGroup,
  InputLeftElement,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Stack,
  Text,
  Icon,
} from "@chakra-ui/react";
import { Search2Icon } from "@chakra-ui/icons";
import { Activity, CircleCheck, CirclePause, CircleStop, List, Loader,Loader2 } from 'lucide-react';

const sampleData = [
  { id: 1, label: "Order Processing", status: "Active" },
  { id: 2, label: "Invoice Sync", status: "Running" },
  { id: 3, label: "Daily Backup", status: "Active" },
  { id: 4, label: "Analytics ETL", status: "Running" },
];
const statusIcons = {
    active: CircleCheck,
    inactive: CirclePause,
    stopped: CircleStop,
    busy: Loader2,
    all:List
  }
/**
 * Searchable list with “Active / Running” status tabs.
 */
export default function SearchWithStatusTabs({ items = sampleData, onFilter=(type:string)=>{} ,setLocalFilter=(lf:string)=>{}}) {
  const [query, setQuery] = useState("");
  const [tabIndex, setTabIndex] = useState(0);      // 0 → Active, 1 → Running

  const filtered = useMemo(() => {
    const status = tabIndex === 0 ? "Active" : "Running";
    return items.filter(
      (it) =>
        it.status === status &&
        it.label.toLowerCase().includes(query.toLowerCase())
    );
  }, [items, query, tabIndex]);

  const getFilterType = (index: number): string => {
    if(index === 0) return "all";
    if(index === 1) return "active";
    if(index === 2) return "busy";
    if(index === 3) return "inactive";
    if(index === 4) return "stopped";

    return "all";
  }
  const onTabChange = (index: number) => {
    setTabIndex(index);
    onFilter(getFilterType(index));
  }

  useEffect(()=>{
    setLocalFilter(query.toLowerCase());
  },[query]);

  return (
    <Box w="100%" maxW="md" mx="auto" background={"black"} color={"white"}>
      {/* Search box */}
     

      {/* Tabs */}
      <Tabs
        index={tabIndex}
        onChange={onTabChange}
        isFitted
        colorScheme="teal"
      >
        <TabList>
          <Tab>  <span className="flex flex-col">
          <Icon as={statusIcons.all}  />
          All</span></Tab>
          <Tab >
            <span className="flex flex-col">
          <Icon as={statusIcons.active}  />
          A</span>

          </Tab>
          <Tab> 
            
          <span className="flex flex-col">
          <Icon  as={statusIcons.busy}  />
          B</span>
          </Tab>
          <Tab>
          <span className="flex flex-col">
          <Icon as={statusIcons.inactive}  />
          I</span>
          </Tab>
          <Tab>
          <span className="flex flex-col">
          <Icon as={statusIcons.stopped}  />
          S</span>
          </Tab>

        </TabList>

        {/* The panels simply show the same filtered list;
            they’re separated so you get automatic TabPanel
            focus/ARIA handling from Chakra */}
        <TabPanels>
          {["Active", "Running"].map((status) => (
            <></>
            // <TabPanel key={status} p={0} pt={4}>
            //   <Stack spacing={3}>
            //     {filtered.length ? (
            //       filtered.map((it) => (
            //         <Box
            //           key={it.id}
            //           p={3}
            //           borderWidth="1px"
            //           borderRadius="lg"
            //           _hover={{ bg: "gray.50" }}
            //         >
            //           <Text fontWeight="medium">{it.label}</Text>
            //           <Text fontSize="sm" color="gray.500">
            //             {it.status}
            //           </Text>
            //         </Box>
            //       ))
            //     ) : (
            //       <Text color="gray.500">No matches</Text>
            //     )}
            //   </Stack>
            // </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
      <InputGroup  p={1} >
        <InputLeftElement pointerEvents="none">
          <Icon as={Search2Icon} boxSize={4} color="gray.400" mt="2" />
        </InputLeftElement>
        <Input
          placeholder="Search..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          borderRadius="lg"
        />
      </InputGroup>
    </Box>
  );
}